import { CartItem } from "@/mocks/cart";

interface Props {
  item: CartItem;
  onQuantityChange: (id: string, qty: number) => void;
  onRemove: (id: string) => void;
}

export default function CartItemRow({ item, onQuantityChange, onRemove }: Props) {
  return (
    <div className="flex gap-4 py-5 border-b border-gray-100 last:border-0">
      <div className="w-20 h-20 rounded-xl overflow-hidden flex-shrink-0 bg-gray-50">
        <img src={item.image} alt={item.title} className="w-full h-full object-cover object-top" />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-semibold text-gray-900 line-clamp-2 mb-1">{item.title}</h3>
        <p className="text-xs text-orange-500 mb-2">{item.seller}</p>
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-2">
            <span className="text-base font-bold text-gray-900">${item.price.toFixed(2)}</span>
            <span className="text-xs text-gray-400 line-through">${item.originalPrice.toFixed(2)}</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => onQuantityChange(item.id, Math.max(1, item.quantity - 1))}
                className="w-8 h-8 flex items-center justify-center text-gray-500 hover:bg-gray-50 cursor-pointer transition-colors"
              >
                <i className="ri-subtract-line text-sm" />
              </button>
              <span className="w-8 text-center text-sm font-semibold text-gray-900">{item.quantity}</span>
              <button
                onClick={() => onQuantityChange(item.id, item.quantity + 1)}
                className="w-8 h-8 flex items-center justify-center text-gray-500 hover:bg-gray-50 cursor-pointer transition-colors"
              >
                <i className="ri-add-line text-sm" />
              </button>
            </div>
            <button
              onClick={() => onRemove(item.id)}
              className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-red-500 cursor-pointer transition-colors"
            >
              <i className="ri-delete-bin-line" />
            </button>
          </div>
        </div>
        <p className="text-xs text-gray-400 mt-1">
          Subtotal: <span className="font-semibold text-gray-700">${(item.price * item.quantity).toFixed(2)}</span>
        </p>
      </div>
    </div>
  );
}
